// /**
//  * NOX DETOX — Pick-Any Bundle Controller
//  * File: custom-bundle-builder.js  v3
//  *
//  * Fixes in this version:
//  *  1. Cart opens correctly via Alpine.store('xMiniCart').openCart()
//  *     — called AFTER sections HTML is patched, with proper rAF timing
//  *  2. Variant selector rendered per-card; JS reads selected variant
//  *  3. Removed all /checkout redirects — SR Smart Cart handles checkout
//  */

// (function () {
//   'use strict';

//   /* ── Money formatter ─────────────────────────────── */
//   function formatMoney(cents, format) {
//     if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
//       return Shopify.formatMoney(cents, format || '₹{{amount_with_comma_separator}}');
//     }
//     return '₹' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//   }

//   function interpolate(str, vars) {
//     return str.replace(/\{\{(\w+)\}\}/g, (_, k) => vars[k] !== undefined ? vars[k] : '');
//   }

//   /* ── Open EURUS mini-cart (from actual source) ───── */
//   function openEurusCart() {
//     // Wait for Alpine to be ready, then call exactly what EURUS does internally
//     const tryOpen = () => {
//       if (window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart')) {
//         window.Alpine.store('xMiniCart').openCart();
//         return true;
//       }
//       return false;
//     };

//     // Try immediately, then retry via rAF if Alpine isn't ready yet
//     if (!tryOpen()) {
//       requestAnimationFrame(() => {
//         if (!tryOpen()) {
//           setTimeout(tryOpen, 100);
//         }
//       });
//     }
//   }

//   /* ── NoxPickBundle ───────────────────────────────── */
//   class NoxPickBundle {
//     constructor(sectionEl) {
//       this.el  = sectionEl;
//       this.sid = sectionEl.dataset.sectionId;

//       const cfgEl = document.getElementById('npb-cfg-' + this.sid);
//       if (!cfgEl) return;
//       this.cfg = JSON.parse(cfgEl.textContent);

//       this.bundleQty   = this.cfg.bundleQty;
//       this.bundlePrice = this.cfg.bundlePrice;
//       // Map: variantId → { variantId, productId, title, price, original, img, qty }
//       this.selected    = new Map();
//       this._loading    = false;

//       this._dom();
//       this._enhanceCards(); // inject variant selectors
//       this._bindCards();
//       this._bindCTA();
//       this._updateUI();

//       // One shared toast per page
//       if (!document.getElementById('npb-toast')) {
//         const t = document.createElement('div');
//         t.id = 'npb-toast'; t.className = 'npb-toast';
//         t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
//         document.body.appendChild(t);
//       }
//       this.toast = document.getElementById('npb-toast');
//     }

//     /* ── DOM refs ──────────────────────────────────── */
//     _dom() {
//       const id = this.sid;
//       this.pfill   = document.getElementById('npb-pfill-'  + id);
//       this.plabel  = document.getElementById('npb-plabel-' + id);
//       this.slots   = document.getElementById('npb-slots-'  + id);
//       this.countEl = document.getElementById('npb-count-'  + id);
//       this.cta     = document.getElementById('npb-cta-'    + id);
//       this.summary = document.getElementById('npb-summary-'+ id);
//       this.chips   = document.getElementById('npb-chips-'  + id);
//       this.stotal  = document.getElementById('npb-stotal-' + id);
//       this.cards   = Array.from(this.el.querySelectorAll('.npb-card'));
//     }

//     /* ── Inject variant dropdowns into cards ────────── */
//     // The liquid renders data-variants-json on each card article.
//     // Here we read it and build a <select> inside .npb-card__body.
//     _enhanceCards() {
//       this.cards.forEach(card => {
//         const raw = card.dataset.variantsJson;
//         if (!raw) return; // single-variant product, nothing to do

//         let variants;
//         try { variants = JSON.parse(raw); } catch { return; }
//         if (!variants || variants.length <= 1) return;

//         // Build select
//         const select = document.createElement('select');
//         select.className = 'npb-variant-select';
//         select.setAttribute('aria-label', 'Select variant');

//         variants.forEach(v => {
//           const opt = document.createElement('option');
//           opt.value = v.id;
//           opt.dataset.price    = v.price;
//           opt.dataset.original = v.compare_at_price || v.price;
//           opt.dataset.avail    = v.available ? '1' : '0';
//           opt.dataset.img      = v.featured_image ? v.featured_image.src : card.dataset.img;
//           opt.textContent      = v.title;
//           opt.disabled         = !v.available;
//           if (!v.available) opt.textContent += ' — Sold Out';
//           select.appendChild(opt);
//         });

//         // Sync card data-* attributes when variant changes
//         select.addEventListener('change', e => {
//           e.stopPropagation();
//           const opt = select.options[select.selectedIndex];
//           const vid = opt.value;

//           card.dataset.variantId = vid;
//           card.dataset.price     = opt.dataset.price;
//           card.dataset.original  = opt.dataset.original;
//           card.dataset.img       = opt.dataset.img || card.dataset.img;
//           card.dataset.available = opt.dataset.avail === '1' ? 'true' : 'false';

//           // If this card was already selected, update the stored item
//           if (this.selected.has(card.dataset.variantId) || this.selected.has(vid)) {
//             // Remove old entry (old variantId), re-add with new one
//             this.selected.forEach((item, key) => {
//               if (item.productId === card.dataset.productId) {
//                 this.selected.delete(key);
//               }
//             });
//             if (opt.dataset.avail === '1') {
//               this.selected.set(vid, {
//                 variantId: vid,
//                 productId: card.dataset.productId,
//                 title:     card.dataset.title + (select.options.length > 1 ? ' · ' + opt.textContent : ''),
//                 price:     parseInt(opt.dataset.price,    10) || 0,
//                 original:  parseInt(opt.dataset.original, 10) || 0,
//                 img:       card.dataset.img,
//                 qty:       1
//               });
//             }
//           }

//           // Mark OOS cards
//           if (opt.dataset.avail !== '1') {
//             card.classList.add('oos');
//             card.classList.remove('selected');
//             card.setAttribute('aria-pressed', 'false');
//           } else {
//             card.classList.remove('oos');
//           }

//           this._updateUI();
//         });

//         card.querySelector('.npb-card__body').appendChild(select);
//       });
//     }

//     /* ── Bind card click/keyboard ───────────────────── */
//     _bindCards() {
//       this.cards.forEach(card => {
//         card.addEventListener('click', e => {
//           if (e.target.closest('.npb-qty'))             return;
//           if (e.target.closest('.npb-variant-select'))  return;
//           if (card.dataset.available === 'false')        return;
//           this._toggle(card);
//         });

//         card.addEventListener('keydown', e => {
//           if ((e.key === 'Enter' || e.key === ' ')
//               && !e.target.closest('.npb-qty')
//               && !e.target.closest('.npb-variant-select')
//               && card.dataset.available !== 'false') {
//             e.preventDefault();
//             this._toggle(card);
//           }
//         });

//         card.querySelector('.npb-qty__minus')?.addEventListener('click', e => {
//           e.stopPropagation(); this._changeQty(card, -1);
//         });
//         card.querySelector('.npb-qty__plus')?.addEventListener('click', e => {
//           e.stopPropagation(); this._changeQty(card, +1);
//         });
//       });
//     }

//     /* ── Toggle selection ───────────────────────────── */
//     _toggle(card) {
//       const vid = card.dataset.variantId;

//       if (this.selected.has(vid)) {
//         this.selected.delete(vid);
//         card.classList.remove('selected');
//         card.setAttribute('aria-pressed', 'false');
//         this._showToast('Removed from bundle');
//       } else {
//         if (this._totalQty() >= this.bundleQty) {
//           this._showToast('Bundle is full — remove a product to swap.');
//           this._shake(this.slots);
//           return;
//         }
//         // Build title with selected variant label if available
//         const select = card.querySelector('.npb-variant-select');
//         const variantLabel = select
//           ? ' · ' + select.options[select.selectedIndex]?.textContent.replace(' — Sold Out', '')
//           : '';

//         this.selected.set(vid, {
//           variantId: vid,
//           productId: card.dataset.productId,
//           title:     card.dataset.title + (select && select.options.length > 1 ? variantLabel : ''),
//           price:     parseInt(card.dataset.price,    10) || 0,
//           original:  parseInt(card.dataset.original, 10) || 0,
//           img:       card.dataset.img,
//           qty:       1
//         });
//         card.classList.add('selected');
//         card.setAttribute('aria-pressed', 'true');

//         const total = this._totalQty();
//         if (total === this.bundleQty) {
//           this._showToast(`🎉 ${this.bundleQty} selected! Tap "Add Bundle to Cart"`);
//         } else {
//           this._showToast(`${this.bundleQty - total} more to unlock bundle price`);
//         }
//       }
//       this._updateUI();
//     }

//     /* ── Qty stepper ────────────────────────────────── */
//     _changeQty(card, delta) {
//       const vid = card.dataset.variantId;
//       if (!this.selected.has(vid)) return;

//       const item   = this.selected.get(vid);
//       const total  = this._totalQty();
//       const newQty = item.qty + delta;

//       if (newQty < 1) {
//         this.selected.delete(vid);
//         card.classList.remove('selected');
//         card.setAttribute('aria-pressed', 'false');
//         this._updateUI();
//         return;
//       }
//       if (delta > 0 && total >= this.bundleQty) {
//         this._showToast(`Bundle full (${this.bundleQty} items). Remove one to add more.`);
//         this._shake(this.slots);
//         return;
//       }
//       item.qty = newQty;
//       this.selected.set(vid, item);
//       const valEl  = card.querySelector('.npb-qty__val');
//       const minBtn = card.querySelector('.npb-qty__minus');
//       if (valEl)  valEl.textContent = newQty;
//       if (minBtn) minBtn.disabled   = newQty <= 1;
//       this._updateUI();
//     }

//     _totalQty() {
//       let n = 0;
//       this.selected.forEach(i => { n += i.qty; });
//       return n;
//     }

//     /* ── Master UI update ───────────────────────────── */
//     _updateUI() {
//       const total   = this._totalQty();
//       const needed  = this.bundleQty;
//       const isReady = total === needed;

//       if (this.pfill) this.pfill.style.width = Math.min((total / needed) * 100, 100) + '%';
//       if (this.plabel) {
//         const rem = needed - total;
//         if (rem <= 0) {
//           this.plabel.textContent = '✓ Bundle complete! Click "Add Bundle to Cart"';
//           this.plabel.classList.add('complete');
//         } else {
//           this.plabel.textContent = interpolate(this.cfg.progressLabel, { remaining: rem });
//           this.plabel.classList.remove('complete');
//         }
//       }
//       if (this.countEl) this.countEl.textContent = total + '/' + needed;

//       if (this.cta) {
//         this.cta.disabled = !isReady;
//         const label = this.cta.querySelector('.npb-cta-label');
//         const price = this.cta.querySelector('.npb-cta__price');
//         if (label) label.textContent = isReady
//           ? (this.cfg.ctaText || 'Add Bundle to Cart')
//           : `Select ${needed - total} more`;
//         if (price) price.style.display = isReady ? '' : 'none';
//       }

//       this._renderSlots();

//       this.selected.forEach((item, vid) => {
//         const card   = this.el.querySelector(`[data-variant-id="${vid}"]`);
//         if (!card) return;
//         const valEl  = card.querySelector('.npb-qty__val');
//         const minBtn = card.querySelector('.npb-qty__minus');
//         if (valEl)  valEl.textContent = item.qty;
//         if (minBtn) minBtn.disabled   = item.qty <= 1;
//       });

//       this._renderSummary(isReady);
//     }

//     /* ── Tray slots ─────────────────────────────────── */
//     _renderSlots() {
//       if (!this.slots) return;
//       const items   = Array.from(this.selected.values());
//       const slotEls = this.slots.querySelectorAll('.npb-slot');

//       slotEls.forEach((slot, i) => {
//         const item = items[i];
//         if (item) {
//           slot.classList.add('filled');
//           if (slot.dataset.filledVid !== item.variantId) {
//             slot.dataset.filledVid = item.variantId;
//             slot.innerHTML = `
//               <img src="${item.img}" alt="${item.title}" loading="lazy" />
//               <button class="npb-slot__remove" type="button"
//                 aria-label="Remove ${item.title}"
//                 data-vid="${item.variantId}">✕</button>`;
//             slot.querySelector('.npb-slot__remove').addEventListener('click', e => {
//               e.stopPropagation();
//               const card = this.el.querySelector(`[data-variant-id="${e.currentTarget.dataset.vid}"]`);
//               if (card) this._toggle(card);
//             });
//           }
//         } else {
//           slot.classList.remove('filled');
//           delete slot.dataset.filledVid;
//           slot.innerHTML = '<span>🌙</span>';
//         }
//       });
//     }

//     /* ── Summary panel ──────────────────────────────── */
//     _renderSummary(isReady) {
//       if (!this.summary) return;
//       if (!isReady || this.selected.size === 0) {
//         this.summary.classList.remove('visible'); return;
//       }
//       this.summary.classList.add('visible');

//       const items     = Array.from(this.selected.values());
//       const origTotal = items.reduce((s, i) => s + i.original * i.qty, 0);
//       const savings   = origTotal - this.bundlePrice;

//       if (this.chips) {
//         this.chips.innerHTML = items.map(it => `
//           <div class="npb-chip">
//             <img src="${it.img}" alt="${it.title}" loading="lazy" />
//             <span>${it.title.length > 30 ? it.title.slice(0, 28) + '…' : it.title}</span>
//             <span class="npb-chip__qty">×${it.qty}</span>
//           </div>`).join('');
//       }

//       if (this.stotal) {
//         this.stotal.innerHTML = `
//           <p class="npb-total-label">Bundle Total</p>
//           <p class="npb-total-price">${formatMoney(this.bundlePrice, this.cfg.moneyFormat)}</p>
//           ${savings > 0 ? `
//             <p class="npb-total-was">${formatMoney(origTotal, this.cfg.moneyFormat)}</p>
//             <p class="npb-total-save">You save ${formatMoney(savings, this.cfg.moneyFormat)}!</p>` : ''}`;
//       }
//     }

//     /* ── CTA bind ───────────────────────────────────── */
//     _bindCTA() {
//       if (!this.cta) return;
//       this.cta.addEventListener('click', () => {
//         if (this._loading || this._totalQty() !== this.bundleQty) return;
//         this._addToCart();
//       });
//     }

//     /* ── Add to cart ─────────────────────────────────
//      *
//      * Flow:
//      *  1. POST /cart/add.js with items + sections to re-render
//      *  2. Patch EURUS section HTML (cart icon count, drawer HTML)
//      *  3. Update Alpine.store('xCartHelper').currentItemCount
//      *  4. Dispatch 'eurus:cart:items-changed'  ← triggers icon badge
//      *  5. Call Alpine.store('xMiniCart').openCart() ← opens drawer
//      *
//      * We do NOT redirect to /checkout. Shiprocket intercepts the
//      * drawer's own checkout button automatically.
//      * ────────────────────────────────────────────── */
//     async _addToCart() {
//       this._setLoading(true);

//       const sectionsToRender = this._getSectionsToRender();

//       try {
//         const resp = await fetch(
//           ((window.Shopify?.routes?.root) || '/') + 'cart/add.js',
//           {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
//             body: JSON.stringify({
//               items: this._buildItems(),
//               sections: sectionsToRender.map(s => s.id)
//             })
//           }
//         );

//         const data = await resp.json();

//         if (data.status === '422' || data.status === 422) {
//           this._showToast('⚠️ ' + (data.description || data.message || this.cfg.errorText));
//           this._setLoading(false);
//           return;
//         }

//         // 1. Patch EURUS section HTML (exactly as xCartHelper.addCartItems does)
//         sectionsToRender.forEach(section => {
//           const el = document.querySelector(section.selector);
//           if (el && data.sections?.[section.id]) {
//             el.innerHTML = this._getSectionInnerHTML(data.sections[section.id], section.selector);
//           }
//         });

//         // 2. Sync Alpine cart item count (source: xCartHelper.addCartItems)
//         const countEl = document.querySelector('#cart-icon-bubble span');
//         if (countEl && window.Alpine?.store?.('xCartHelper')) {
//           window.Alpine.store('xCartHelper').currentItemCount = parseInt(countEl.innerHTML || '0', 10);
//         }

//         // 3. Fire EURUS cart-changed event (updates badge, upsells, etc.)
//         document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true }));

//         // 4. Show success toast
//         this._showToast(this.cfg.successText || '🎉 Bundle added to cart!');
//         this._setLoading(false);

//         // 5. Open the EURUS mini-cart / drawer
//         //    Small rAF delay so patched HTML is painted before open animation
//         // requestAnimationFrame(() => {
//         //   openEurusCart();
//         // });

//                 document.dispatchEvent(
//           new CustomEvent('eurus:cart:items-changed', {
//             bubbles: true
//           })
//         );

//         document.dispatchEvent(
//           new CustomEvent('cart:refresh', {
//             bubbles: true
//           })
//         );

//         window.dispatchEvent(
//           new Event('cart:refresh')
//         );

//         // setTimeout(() => {

//         //   if (
//         //     window.Alpine &&
//         //     Alpine.store &&
//         //     Alpine.store('xMiniCart')
//         //   ) {
//         //     Alpine.store('xMiniCart').openCart();
//         //   }

//         //   document.dispatchEvent(
//         //     new CustomEvent('cart:open', {
//         //       bubbles: true
//         //     })
//         //   );

//         // }, 300);

// // Show success toast
// this._showToast(this.cfg.successText || '🎉 Bundle added to cart!');
// this._setLoading(false);


// setTimeout(async () => {

//   const cart = await fetch('/cart.js').then(r => r.json());

//   window.shiprocketSmartCart.currentCart = cart;

//   if (typeof updateMiniCartSection === 'function') {
//     updateMiniCartSection();
//   }

//   setTimeout(() => {

//     if (typeof srShowMiniCartDrawer === 'function') {
//       srShowMiniCartDrawer();
//     }

//     document.querySelector('#cart-icon')?.click();

//   }, 300);

// }, 1000);

//       } catch (err) {
//         console.error('[NoxPickBundle] Cart error:', err);
//         this._showToast(this.cfg.errorText || 'Something went wrong. Please try again.');
//         this._setLoading(false);
//       }
//     }

//     /* ── Build /cart/add.js items array ─────────────── */
//     _buildItems() {
//       const items = [];
//       this.selected.forEach(item => {
//         items.push({
//           id:       parseInt(item.variantId, 10),
//           quantity: item.qty,
//           properties: {
//             '_bundle':         'Night Kit Bundle',
//             '_bundle_price':   formatMoney(this.bundlePrice, this.cfg.moneyFormat),
//             '_bundle_section': this.sid
//           }
//         });
//       });
//       return items;
//     }

//     /* ── Sections to re-render (mirrors xCartHelper) ── */
//     _getSectionsToRender() {
//       if (window.Alpine?.store?.('xCartHelper')
//           && typeof window.Alpine.store('xCartHelper').getSectionsToRender === 'function') {
//         return window.Alpine.store('xCartHelper').getSectionsToRender();
//       }
//       // Fallback matching EURUS defaults (from the source you shared)
//       return [
//         { id: 'cart-icon-bubble',        selector: '#cart-icon-bubble' },
//         { id: 'mobile-cart-icon-bubble', selector: '#mobile-cart-icon-bubble' },
//         { id: 'cart-drawer',             selector: '#CartDrawer' }
//       ];
//     }

//     /* ── getSectionInnerHTML (global in EURUS) ────────  */
//     _getSectionInnerHTML(html, selector) {
//       if (typeof getSectionInnerHTML === 'function') {
//         return getSectionInnerHTML(html, selector);
//       }
//       return new DOMParser()
//         .parseFromString(html, 'text/html')
//         .querySelector(selector)?.innerHTML || '';
//     }

//     /* ── Loading state ──────────────────────────────── */
//     _setLoading(state) {
//       this._loading = state;
//       if (!this.cta) return;
//       this.cta.classList.toggle('loading', state);
//       this.cta.disabled = state;
//     }

//     /* ── Toast ──────────────────────────────────────── */
//     _showToast(msg) {
//       if (!this.toast) return;
//       clearTimeout(this._toastTimer);
//       this.toast.textContent = msg;
//       this.toast.classList.add('show');
//       this._toastTimer = setTimeout(() => this.toast.classList.remove('show'), 3000);
//     }

//     /* ── Shake ──────────────────────────────────────── */
//     _shake(el) {
//       if (!el) return;
//       el.classList.remove('npb-shake');
//       void el.offsetWidth;
//       el.classList.add('npb-shake');
//       el.addEventListener('animationend', () => el.classList.remove('npb-shake'), { once: true });
//     }
//   }

//   /* ── Boot ────────────────────────────────────────── */
//   function initAll() {
//     document.querySelectorAll('.nox-pick-bundle').forEach(el => {
//       if (!el.dataset._npbInit) {
//         el.dataset._npbInit = '1';
//         new NoxPickBundle(el);
//       }
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initAll);
//   } else {
//     initAll();
//   }

//   document.addEventListener('shopify:section:load', e => {
//     const sec = e.target.querySelector('.nox-pick-bundle');
//     if (sec) { delete sec.dataset._npbInit; initAll(); }
//   });

//   window.NoxPickBundle = NoxPickBundle;
// })(); 



/**
 * NOX DETOX — Pick-Any Bundle Controller
 * File: custom-bundle-builder.js  v4
 *
 * Changes from v3:
 *  1. Each card now has an "ADD TO BOX / REMOVE" button (like Adil Qadri reference)
 *     — card-click-to-select is removed so it doesn't conflict with variant dropdown
 *  2. Variant-change deselect bug fixed:
 *     — selected Map now keyed by productId, not variantId
 *     — switching variant on an already-selected card updates the stored entry in place
 *     — ADD TO BOX / REMOVE button always works regardless of which variant is active
 */

/**
 * NOX DETOX — Pick-Any Bundle Controller
 * File: custom-bundle-builder.js  v4
 *
 * Changes from v3:
 *  1. Each card now has an "ADD TO BOX / REMOVE" button (like Adil Qadri reference)
 *     — card-click-to-select is removed so it doesn't conflict with variant dropdown
 *  2. Variant-change deselect bug fixed:
 *     — selected Map now keyed by productId, not variantId
 *     — switching variant on an already-selected card updates the stored entry in place
 *     — ADD TO BOX / REMOVE button always works regardless of which variant is active
 */

/**
 * NOX DETOX — Pick-Any Bundle Controller
 * File: custom-bundle-builder.js  v5
 *
 * Fix in v5:
 *  _renderSlots() now expands items by qty into a flat units list.
 *  e.g. Product A (qty=3) fills all 3 tray slots with Product A's image.
 *  Clicking X on a slot reduces qty by 1 (or fully removes if qty=1).
 */

(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format || '{{amount_with_comma_separator}}');
    }
    return (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function interpolate(str, vars) {
    return str.replace(/\{\{(\w+)\}\}/g, (_, k) => vars[k] !== undefined ? vars[k] : '');
  }

  class NoxPickBundle {
    constructor(sectionEl) {
      this.el  = sectionEl;
      this.sid = sectionEl.dataset.sectionId;

      const cfgEl = document.getElementById('npb-cfg-' + this.sid);
      if (!cfgEl) return;
      this.cfg = JSON.parse(cfgEl.textContent);

      this.bundleQty   = this.cfg.bundleQty;
      this.bundlePrice = this.cfg.bundlePrice;

      // Map<productId, { productId, variantId, title, variantLabel, price, original, img, qty }>
      this.selected = new Map();
      this._loading = false;

      this._dom();
      this._enhanceCards();
      this._bindCTA();
      this._updateUI();

      if (!document.getElementById('npb-toast')) {
        const t = document.createElement('div');
        t.id = 'npb-toast'; t.className = 'npb-toast';
        t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
        document.body.appendChild(t);
      }
      this.toast = document.getElementById('npb-toast');
    }

    _dom() {
      const id = this.sid;
      this.pfill   = document.getElementById('npb-pfill-'   + id);
      this.plabel  = document.getElementById('npb-plabel-'  + id);
      this.slots   = document.getElementById('npb-slots-'   + id);
      this.countEl = document.getElementById('npb-count-'   + id);
      this.cta     = document.getElementById('npb-cta-'     + id);
      this.summary = document.getElementById('npb-summary-' + id);
      this.chips   = document.getElementById('npb-chips-'   + id);
      this.stotal  = document.getElementById('npb-stotal-'  + id);
      this.savings = document.getElementById('npb-savings-' + id);
      this.cards   = Array.from(this.el.querySelectorAll('.npb-card'));
    }

    _enhanceCards() {
      this.cards.forEach(card => {
        const pid = card.dataset.productId;
        if (!pid) return;

        // Variant dropdown
        const raw = card.dataset.variantsJson;
        let variants = null;
        if (raw) { try { variants = JSON.parse(raw); } catch { variants = null; } }

        if (variants && variants.length > 1) {
          const select = document.createElement('select');
          select.className = 'npb-variant-select';
          select.setAttribute('aria-label', 'Select variant');
          variants.forEach(v => {
            const opt = document.createElement('option');
            opt.value            = v.id;
            opt.dataset.price    = v.price;
            opt.dataset.original = v.compare_at_price || v.price;
            opt.dataset.avail    = v.available ? '1' : '0';
            opt.dataset.img      = (v.featured_image && v.featured_image.src) || card.dataset.img;
            opt.textContent      = v.title + (v.available ? '' : ' — Sold Out');
            opt.disabled         = !v.available;
            select.appendChild(opt);
          });
          card.querySelector('.npb-card__body').appendChild(select);
          select.addEventListener('change', () => this._onVariantChange(card, select));
        }

        // ADD TO BOX button
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'npb-atb-btn';
        btn.setAttribute('aria-label', 'Add to box');
        btn.innerHTML =
          '<span class="npb-atb-add">' +
            '<svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"/></svg>' +
            ' ADD TO BOX' +
          '</span>' +
          '<span class="npb-atb-remove">' +
            '<svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M3 10a.75.75 0 01.75-.75h12.5a.75.75 0 010 1.5H3.75A.75.75 0 013 10z" clip-rule="evenodd"/></svg>' +
            ' REMOVE' +
          '</span>';
        btn.addEventListener('click', e => { e.stopPropagation(); this._toggleByProduct(card); });
        card.querySelector('.npb-card__body').appendChild(btn);
      });
    }

    _onVariantChange(card, select) {
      const opt   = select.options[select.selectedIndex];
      const pid   = card.dataset.productId;
      const avail = opt.dataset.avail === '1';

      card.dataset.variantId = opt.value;
      card.dataset.price     = opt.dataset.price;
      card.dataset.original  = opt.dataset.original;
      card.dataset.img       = opt.dataset.img || card.dataset.img;
      card.dataset.available = avail ? 'true' : 'false';

      if (!avail) {
        if (this.selected.has(pid)) { this.selected.delete(pid); this._setCardState(card, false); }
        card.classList.add('oos');
      } else {
        card.classList.remove('oos');
        if (this.selected.has(pid)) {
          const entry = this.selected.get(pid);
          entry.variantId    = opt.value;
          entry.price        = parseInt(opt.dataset.price, 10) || 0;
          entry.original     = parseInt(opt.dataset.original, 10) || 0;
          entry.img          = card.dataset.img;
          entry.variantLabel = opt.textContent.replace(' — Sold Out', '');
          this.selected.set(pid, entry);
        }
      }
      this._updateUI();
    }

    _toggleByProduct(card) {
      const pid   = card.dataset.productId;
      const avail = card.dataset.available !== 'false';
      if (!avail) { this._showToast('This variant is sold out. Please choose another.'); return; }

      if (this.selected.has(pid)) {
        this.selected.delete(pid);
        this._setCardState(card, false);
        this._showToast('Removed from bundle');
      } else {
        if (this._totalQty() >= this.bundleQty) {
          this._showToast('Bundle is full — remove a product to swap.');
          this._shake(this.slots); return;
        }
        const select = card.querySelector('.npb-variant-select');
        const variantLabel = select ? select.options[select.selectedIndex]?.textContent.replace(' — Sold Out', '') : '';
        this.selected.set(pid, {
          productId: pid, variantId: card.dataset.variantId,
          title: card.dataset.title, variantLabel,
          price:    parseInt(card.dataset.price, 10) || 0,
          original: parseInt(card.dataset.original, 10) || 0,
          img: card.dataset.img, qty: 1
        });
        this._setCardState(card, true);
        const total = this._totalQty();
        this._showToast(total === this.bundleQty
          ? `\uD83C\uDF89 ${this.bundleQty} selected! Tap "Add Bundle to Cart"`
          : `${this.bundleQty - total} more to unlock bundle price`);
      }
      this._updateUI();
    }

    _setCardState(card, isSelected) {
      card.classList.toggle('selected', isSelected);
      card.setAttribute('aria-pressed', String(isSelected));
      const btn = card.querySelector('.npb-atb-btn');
      if (btn) btn.classList.toggle('is-selected', isSelected);
    }

    _bindQtySteppers(card) {
      card.querySelector('.npb-qty__minus')?.addEventListener('click', e => { e.stopPropagation(); this._changeQty(card, -1); });
      card.querySelector('.npb-qty__plus')?.addEventListener('click',  e => { e.stopPropagation(); this._changeQty(card, +1); });
    }

    _changeQty(card, delta) {
      const pid = card.dataset.productId;
      if (!this.selected.has(pid)) return;
      const item = this.selected.get(pid);
      const newQty = item.qty + delta;
      if (newQty < 1) {
        this.selected.delete(pid); this._setCardState(card, false); this._updateUI(); return;
      }
      if (delta > 0 && this._totalQty() >= this.bundleQty) {
        this._showToast(`Bundle full (${this.bundleQty} items). Remove one to add more.`);
        this._shake(this.slots); return;
      }
      item.qty = newQty;
      this.selected.set(pid, item);
      const valEl  = card.querySelector('.npb-qty__val');
      const minBtn = card.querySelector('.npb-qty__minus');
      if (valEl)  valEl.textContent = newQty;
      if (minBtn) minBtn.disabled   = newQty <= 1;
      this._updateUI();
    }

    _totalQty() {
      let n = 0; this.selected.forEach(i => { n += i.qty; }); return n;
    }

    _updateUI() {
      const total   = this._totalQty();
      const needed  = this.bundleQty;
      const isReady = total === needed;

      if (this.pfill)  this.pfill.style.width = Math.min((total / needed) * 100, 100) + '%';
      if (this.plabel) {
        const rem = needed - total;
        if (rem <= 0) { this.plabel.textContent = '\u2713 Bundle complete! Click "Add Bundle to Cart"'; this.plabel.classList.add('complete'); }
        else          { this.plabel.textContent = interpolate(this.cfg.progressLabel, { remaining: rem }); this.plabel.classList.remove('complete'); }
      }
      if (this.countEl) this.countEl.textContent = total + '/' + needed;

      if (this.cta) {
        this.cta.disabled = !isReady;
        const label = this.cta.querySelector('.npb-cta-label');
        const price = this.cta.querySelector('.npb-cta__price');
        if (label) label.textContent = isReady ? (this.cfg.ctaText || 'Add Bundle to Cart') : `Select ${needed - total} more`;
        if (price) price.style.display = isReady ? '' : 'none';
      }

      this.cards.forEach(card => {
        const pid  = card.dataset.productId;
        const isOn = this.selected.has(pid);
        const item = this.selected.get(pid);
        this._setCardState(card, isOn);
        if (isOn && !card._qtyBound) { card._qtyBound = true; this._bindQtySteppers(card); }
        const valEl  = card.querySelector('.npb-qty__val');
        const minBtn = card.querySelector('.npb-qty__minus');
        if (valEl && item)  valEl.textContent = item.qty;
        if (minBtn && item) minBtn.disabled   = item.qty <= 1;
      });

      this._renderSlots();
      this._renderSummary(isReady);
    }

    /* ═══════════════════════════════════════════════════════════════
       _renderSlots — KEY FIX
       Expand each item by its qty into a flat "units" array first.
       e.g. Product A (qty=3) → [A, A, A]
            Product A (qty=2) + Product B (qty=1) → [A, A, B]
       Each tray slot maps to exactly 1 unit.
       Clicking X on a slot: reduces qty by 1, or fully removes if qty was 1.
       ═══════════════════════════════════════════════════════════════ */
    _renderSlots() {
      if (!this.slots) return;

      // Build flat units list ordered by insertion
      const units = [];
      this.selected.forEach(item => {
        for (let q = 0; q < item.qty; q++) units.push(item);
      });

      const slotEls = this.slots.querySelectorAll('.npb-slot');

      slotEls.forEach((slot, i) => {
        const item = units[i];

        if (item) {
          slot.classList.add('filled');
          // Unique key: productId + slot-index (not just productId!)
          // This forces a re-render when the same product fills multiple slots
          const key = item.productId + ':' + i;
          if (slot.dataset.slotKey === key) return; // unchanged
          slot.dataset.slotKey = key;

          slot.innerHTML =
            '<img src="' + item.img + '" alt="' + item.title + '" loading="lazy" />' +
            '<button class="npb-slot__remove" type="button"' +
            ' aria-label="Remove ' + item.title + '"' +
            ' data-pid="' + item.productId + '">\u2715</button>';

          slot.querySelector('.npb-slot__remove').addEventListener('click', e => {
            e.stopPropagation();
            const pid   = e.currentTarget.dataset.pid;
            const entry = this.selected.get(pid);
            if (!entry) return;

            if (entry.qty > 1) {
              // Reduce by 1 unit — card stays selected
              entry.qty -= 1;
              this.selected.set(pid, entry);
              const card = this.el.querySelector('[data-product-id="' + pid + '"]');
              if (card) {
                const valEl  = card.querySelector('.npb-qty__val');
                const minBtn = card.querySelector('.npb-qty__minus');
                if (valEl)  valEl.textContent = entry.qty;
                if (minBtn) minBtn.disabled   = entry.qty <= 1;
              }
              this._updateUI();
            } else {
              // Last unit — fully deselect
              const card = this.el.querySelector('[data-product-id="' + pid + '"]');
              if (card) this._toggleByProduct(card);
            }
          });

        } else {
          // Empty slot
          if (slot.dataset.slotKey) {
            delete slot.dataset.slotKey;
            slot.classList.remove('filled');
            slot.innerHTML = '<span>\uD83C\uDF19</span>';
          }
        }
      });
    }

    _renderSummary(isReady) {
      // Tray savings
      if (this.savings) {
        if (isReady && this.selected.size > 0) {
          const origTot = Array.from(this.selected.values()).reduce((s, i) => s + i.original * i.qty, 0);
          const saved   = origTot - this.bundlePrice;
          if (saved > 0) { this.savings.textContent = 'You save ' + formatMoney(saved, this.cfg.moneyFormat) + '!'; this.savings.classList.add('visible'); }
          else             this.savings.classList.remove('visible');
        } else { this.savings.classList.remove('visible'); }
      }

      if (!this.summary) return;
      if (!isReady || this.selected.size === 0) { this.summary.classList.remove('visible'); return; }
      this.summary.classList.add('visible');

      const items     = Array.from(this.selected.values());
      const origTotal = items.reduce((s, i) => s + i.original * i.qty, 0);
      const savings   = origTotal - this.bundlePrice;

      if (this.chips) {
        this.chips.innerHTML = items.map(it => {
          const label = (it.variantLabel && it.variantLabel !== 'Default Title') ? ' \u00b7 ' + it.variantLabel : '';
          const name  = (it.title + label);
          return '<div class="npb-chip">' +
            '<img src="' + it.img + '" alt="' + it.title + '" loading="lazy" />' +
            '<span>' + (name.length > 34 ? name.slice(0,32) + '\u2026' : name) + '</span>' +
            '<span class="npb-chip__qty">\u00d7' + it.qty + '</span>' +
            '</div>';
        }).join('');
      }

      if (this.stotal) {
        this.stotal.innerHTML =
          '<p class="npb-total-label">Bundle Total</p>' +
          '<p class="npb-total-price">' + formatMoney(this.bundlePrice, this.cfg.moneyFormat) + '</p>' +
          (savings > 0
            ? '<p class="npb-total-was">' + formatMoney(origTotal, this.cfg.moneyFormat) + '</p>' +
              '<p class="npb-total-save">You save ' + formatMoney(savings, this.cfg.moneyFormat) + '!</p>'
            : '');
      }
    }

    _bindCTA() {
      if (!this.cta) return;
      this.cta.addEventListener('click', () => {
        if (this._loading || this._totalQty() !== this.bundleQty) return;
        this._addToCart();
      });
    }

    async _addToCart() {
      this._setLoading(true);
      const sectionsToRender = this._getSectionsToRender();
      try {
        const resp = await fetch(
          ((window.Shopify?.routes?.root) || '/') + 'cart/add.js',
          {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body:    JSON.stringify({ items: this._buildItems(), sections: sectionsToRender.map(s => s.id) })
          }
        );
        const data = await resp.json();

        if (data.status === '422' || data.status === 422) {
          this._showToast('\u26a0\ufe0f ' + (data.description || data.message || this.cfg.errorText));
          this._setLoading(false); return;
        }

        sectionsToRender.forEach(section => {
          const el = document.querySelector(section.selector);
          if (el && data.sections?.[section.id])
            el.innerHTML = this._getSectionInnerHTML(data.sections[section.id], section.selector);
        });

        const countEl = document.querySelector('#cart-icon-bubble span');
        if (countEl && window.Alpine?.store?.('xCartHelper'))
          window.Alpine.store('xCartHelper').currentItemCount = parseInt(countEl.innerHTML || '0', 10);

        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh',             { bubbles: true }));
        window.dispatchEvent(new Event('cart:refresh'));

        this._showToast(this.cfg.successText || '\uD83C\uDF89 Bundle added to cart!');
        this._setLoading(false);

        setTimeout(async () => {
          try {
            const cart = await fetch('/cart.js').then(r => r.json());
            if (window.shiprocketSmartCart) window.shiprocketSmartCart.currentCart = cart;
            if (typeof updateMiniCartSection === 'function') updateMiniCartSection();
            setTimeout(() => {
              if (typeof srShowMiniCartDrawer === 'function') srShowMiniCartDrawer();
              document.querySelector('#cart-icon')?.click();
            }, 300);
          } catch (_) {
            requestAnimationFrame(() => {
              if (window.Alpine?.store?.('xMiniCart')) window.Alpine.store('xMiniCart').openCart();
            });
          }
        }, 800);

      } catch (err) {
        console.error('[NoxPickBundle] Cart error:', err);
        this._showToast(this.cfg.errorText || 'Something went wrong. Please try again.');
        this._setLoading(false);
      }
    }

    _buildItems() {
      const items = [];
      this.selected.forEach(item => {
        items.push({
          id: parseInt(item.variantId, 10), quantity: item.qty,
          properties: { '_bundle': 'Night Kit Bundle', '_bundle_price': formatMoney(this.bundlePrice, this.cfg.moneyFormat), '_bundle_section': this.sid }
        });
      });
      return items;
    }

    _getSectionsToRender() {
      if (window.Alpine?.store?.('xCartHelper') && typeof window.Alpine.store('xCartHelper').getSectionsToRender === 'function')
        return window.Alpine.store('xCartHelper').getSectionsToRender();
      return [
        { id: 'cart-icon-bubble',        selector: '#cart-icon-bubble' },
        { id: 'mobile-cart-icon-bubble', selector: '#mobile-cart-icon-bubble' },
        { id: 'cart-drawer',             selector: '#CartDrawer' }
      ];
    }

    _getSectionInnerHTML(html, selector) {
      if (typeof getSectionInnerHTML === 'function') return getSectionInnerHTML(html, selector);
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
    }

    _setLoading(state) {
      this._loading = state; if (!this.cta) return;
      this.cta.classList.toggle('loading', state); this.cta.disabled = state;
    }

    _showToast(msg) {
      if (!this.toast) return;
      clearTimeout(this._toastTimer); this.toast.textContent = msg; this.toast.classList.add('show');
      this._toastTimer = setTimeout(() => this.toast.classList.remove('show'), 3000);
    }

    _shake(el) {
      if (!el) return; el.classList.remove('npb-shake'); void el.offsetWidth;
      el.classList.add('npb-shake');
      el.addEventListener('animationend', () => el.classList.remove('npb-shake'), { once: true });
    }
  }

  function initAll() {
    document.querySelectorAll('.nox-pick-bundle').forEach(el => {
      if (!el.dataset._npbInit) { el.dataset._npbInit = '1'; new NoxPickBundle(el); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', e => {
    const sec = e.target.querySelector('.nox-pick-bundle');
    if (sec) { delete sec.dataset._npbInit; initAll(); }
  });

  window.NoxPickBundle = NoxPickBundle;
})();